let all_images, inventory_data, collection_data, color_dictionary;
const chip_svg = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 37 40"><path d="M21.3 23l11-11c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0l-11 11-11-11c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l11 11-11 11c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6l11-11 11 11c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2 0-2.8l-11-11z"/></svg>`
const privateCollection = 'private-sale';
const current_collection_private = $('input#hidden-current-collection').val();
// const colorJsonUrl = document.getElementById('color-json-url').value;
async function fetchProductData(handle) {
    return fetch(`/products/${handle}.js`)
        .then(response => {
            if (!response.ok) {
                return;
            }
            return response.json();
        })
        .then(product => product)
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        });
}
$(function(){
    // Initialization
    const current_collection_id = $('input#hidden-current-collection-id').val();
    const current_collection = $('input#hidden-current-collection').val();
    // Check if page loaded is same Collection as Storage data
    const isSameCollection = setStorageCollectionID(current_collection_id);
    // Init conditions
    let conditions = defaultConditions();



    // Fetch required data all at once
    Promise.all([
        fetch(`/collections/${current_collection}?view=images`).then(resp => resp.json()),
        fetch(`https://api.ecom.amsale.com/api/inventory/${current_collection_id}/products`).then(resp => resp.json()),
        fetch(`/collections/${current_collection}?view=filtering`).then(resp => resp.json()),
        // fetch(colorJsonUrl).then(resp => resp.json()),
        
    ]).then((values) => {
        all_images = values[0];
        if (values[1].products !== null) {
            inventory_data = values[1];
        } else {
            // If Inventory is NULL because of a Shopify/API issue
            // We hide the Stocks checkboxes
            $('.sizes-wrapper').hide().next('hr').hide();
        }

        collection_data = values[2];
        color_dictionary = values[3];
        let path_tag = getPreFilteredTag(window.location.pathname);
        
        // If it has one, filter again by that tag
        if (path_tag) {
            collection_data.products = collection_data.products.filter(p => {
                const cleanedTags = convertAndCleanTags(p.tags);
                return cleanedTags.includes(path_tag)
            });
            if (inventory_data) {
                inventory_data.products = inventory_data.products.filter(p => {
                    const cleanedTags = convertAndCleanTags(p.tags);
                    return cleanedTags.includes(path_tag)
                });
            }            
            all_images.products = all_images.products.filter(p => {
                const cleanedTags = convertAndCleanTags(p.tags);
                return cleanedTags.includes(path_tag)
            });
        }
        
        // Check if same Collection
        if (isSameCollection) {
            // If it is, we retrieve the conditions from Storage
            conditions = applyConditionsFromStorage();
        } else {
            // If not, we reset everything
            setSessionStorage(conditions);
            // resetFiltersSimple();
            $('ul.product-cards-container').css('opacity', '1');
        }
      });     
      


      if (current_collection_private === privateCollection) {
        async function fetchCollectionProducts(collectionHandle, page = 1, products = []) {
            const response = await fetch(`/collections/${collectionHandle}/products.json?page=${page}`);
            const data = await response.json();
        
            if (data.products.length > 0) {
                products = products.concat(data.products);
                return fetchCollectionProducts(collectionHandle, page + 1, products);
            } else {
                return products;
            }
        }
    

    
        function getFirstCompareAtPrice(product) {
       
                return product.compare_at_price;
            
        }
    
        function fetchHandleForPrivateProduct() {
            fetchCollectionProducts(privateCollection)
                .then(privateProducts => {
                    const productHandles = privateProducts.map(privateProduct => privateProduct.handle);
    
                    Promise.all(productHandles.map(handle => fetchProductData(handle)))
                        .then(productDetails => {
                            const productData = {};
                            productDetails.forEach(product => {
                                productData[product.handle] = getFirstCompareAtPrice(product);
                            });
        
                            // Now use the fetched data to append product cards
                            appendCollectionListHtml(productDetails, productData);
                        });
                });
        }
    
        fetchHandleForPrivateProduct();
        
    }
    

    // Handle checkbox click
    $('input.checkb-filter').on('click', function(){   
        // Check if we have Sizes selected
        const is_api_check = is_api();
        // set proper conditions
        conditions = setFilterConditions(isChecked($(this)), $(this).val(), $(this).data(), conditions);
        // filter
        filterByManyConditions(getDataToFilter(is_api_check), conditions, is_api_check);
        // display clear filters button
        handleClearAction('show');
        handleFilterChip(this);
    });

    // Example usage for the private-sale collection
    
        
    // Handle Collection refinement
    $('a.collection-filter').on('click', function(){
        // Check if we have Sizes selected
        const is_api_check = is_api();
        conditions = getSessionStorage();
        if ($(this).data().type) {
            // set active collection link
            conditions = handleActiveCollection($(this), conditions);
            filterByManyConditions(getDataToFilter(is_api_check), conditions, is_api_check);
            handleClearAction('show');
        }
    });

    // Handle reset filters
    $('a.clear-filters').on('click', function () {
        handleClearAction('hide');
        conditions = resetFilters(conditions);
    });




    // On mobile, open off-canvas filter drawer    
    $(document).on('click', 'button.open-refine-section', function(e){
        e.preventDefault();
        $('#shopify-section-header').addClass('hide-header');
        $('.filter-refine-section').addClass('show-section');
        $('.grid__item--sidebar').addClass('open-drawer');
        $("html, body").addClass('sidebar-open');
        $('#zsiq_float').hide();
        return false;
    });

    $(document).on('click', 'button.open-filters-section', function(e){
        e.preventDefault();
        $('#shopify-section-header').addClass('hide-header');
        $('.filter-section').addClass('show-section');
        $('.grid__item--sidebar').addClass('open-drawer');
        $("html, body").addClass('sidebar-open');
        $('#zsiq_float').hide();
        return false;
    });
    
    // On mobile, close off-canvas filter drawer
    $(document).on('click', 'button#close-drawer-btn, button.apply-filters-btn', function(e){
        e.preventDefault();
        $('.grid__item--sidebar').removeClass('open-drawer');
        $("html, body").removeClass('sidebar-open');
        $('#zsiq_float').css('display', 'inline-block');
        $('.filter-refine-section, .filter-section').removeClass('show-section');
        $('#shopify-section-header').removeClass('hide-header');
        return false;
    });

    // Capture User scroll position on product card click
    $(document).on('click', '.custom__product-card a', function(e){
        e.preventDefault();
        let sessionData = getSessionStorage();
        if (sessionData) {
            let scrollPosition = sessionData.filter(c => c.type === 'scroll');
            scrollPosition[0].value = window.scrollY;            
            setSessionStorage(sessionData);
        }
        // Redirect to PDP
        window.location = $(this).attr('href');
    });

    // Initialize Price Range
    const rangeInput = document.querySelectorAll(".range-input input"),
    range = document.querySelector(".slider .progress");
    const priceGap = parseInt(range.dataset.gap);

    // Price input range handler
    rangeInput.forEach(input =>{       
        input.addEventListener("input", e => {
            let minVal = parseInt(rangeInput[0].value);
            let maxVal = parseInt(rangeInput[1].value);
            const currentInput = e.target.classList[0];
            const realMin = rangeInput[0].min;
            const realMax = rangeInput[0].max;
    
            // Ensure handles don't collide and maintain the gap
            if ((maxVal - minVal) < priceGap) {
                if (currentInput === "range-min") {
                    rangeInput[0].value = maxVal - priceGap;
                    minVal = maxVal - priceGap; // Update minVal
                } else {
                    rangeInput[1].value = minVal + priceGap;
                    maxVal = minVal + priceGap; // Update maxVal
                }
            }
    
            // Update slider track positions            
            const minPosition = ((minVal - realMin) / (realMax - realMin)) * 100;
            const maxPosition = ((maxVal - realMin) / (realMax - realMin)) * 100;
            range.style.left = minPosition + "%";
            range.style.right = 100 - maxPosition + "%";

            // Limit Range with price gap            
            if (currentInput === 'range-min' && minVal <= (maxVal - priceGap)) {
                $('span.lowest-range').text(`$${minVal}`);
            } else if (currentInput === 'range-max' && maxVal >= (minVal + priceGap)) {
                $('span.highest-range').text(`$${maxVal}`);
            }            
        });

        // Handle Price Range input change
        input.addEventListener('change', e => {
            const is_api_check = is_api();
            const range_array_values = [parseInt($('input.range-min').val()), parseInt($('input.range-max').val())];
            conditions = setFilterConditions(false, range_array_values, e.target.dataset, conditions);
            filterByManyConditions(getDataToFilter(is_api_check), conditions, is_api_check);
            handleClearAction('show');
            handleFilterChip({min: range_array_values[0], max: range_array_values[1]})
        });
    });

});

function filterByFabric(data, fabricTags) {    
    return data.filter(item => {
        return fabricTags.some(fabricTag => {
            const cleanedTags = convertAndCleanTags(item.tags);
            return cleanedTags.includes(fabricTag)
        });
    });
}

function filterByColor(data, colorTags) {    
    return data.filter(item => {
        return colorTags.some(colorTag => {
            if (colorTag === 'ivory') {
                return item.swatches.includes(colorTag);
            } else {
                const cleanedTags = convertAndCleanTags(item.tags);
                return cleanedTags.includes(colorTag);
            }
        });
    });
}


// Call this function when needed

function filterByCollection(data, collectionName = '') {
    return data.filter(product => product.collections.some(collection => collection.handle === collectionName))
}

function filterByPrice(data, price, is_api = false) {
    const min = price[0];
    const max = price[1];

    return data.filter(item => {
        let current_price = 0;
        let parsed_price = 0;

        if (is_api) {
            current_price = item.variants[0].price;
        } else {
            current_price = item.variant[0].price_without_currency;
        }

        if (isInteger(current_price)) {
            parsed_price = parseInt(current_price);
        } else {
            parsed_price = parseDecimal(current_price);
        }
        return parsed_price >= min && parsed_price <= max;
    });
}

function filterInventory(data, conditions, products = []) {
    const fabric_conditions = conditions.find(c => c.type === 'fabric') || { value: [] };
    const color_conditions = conditions.find(c => c.type === 'color') || { value: [] };
    const size_conditions = conditions.find(c => c.type === 'size') || { value: [] };

    const size_values = size_conditions.value;
    const color_values = color_conditions.value;
    const fabric_values = fabric_conditions.value;

    return data.filter(p =>
      p.variants.some(v => {
          const hasSize = size_values.length === 0 || size_values.includes(v.option1.toLowerCase()) || size_values.includes(v.option2 && v.option2.toLowerCase());
          const hasColor = color_values.length === 0 || v.tags.split(', ').some(tag => color_values.includes(tag));
          const hasFabric = fabric_values.length === 0 || p.tags.split(', ').some(tag => fabric_values.includes(tag));

          return hasSize && hasColor && hasFabric;
      })
    );
}

function filterByManyConditions(data, conditions, is_api = false) {
    let filteredResults, filteredFabrics, filteredColors, filteredPrices, first_color, first_size;
    let current_data = data;

    fabric_conditions = conditions.filter(c => c.type === 'fabric');
    color_conditions = conditions.filter(c => c.type === 'color');
    price_conditions = conditions.filter(c => c.type === 'price');
    size_conditions = conditions.filter(c => c.type === 'size');
    availability_conditions = conditions.filter(c => c.type === 'availability');
    
    const madeToOrderSelected = availability_conditions.length > 0 && 
                              availability_conditions[0].value.includes('made-to-order') && 
                              !availability_conditions[0].value.includes('in-stock');
    
    
    if (madeToOrderSelected) {
        current_data = current_data.filter(product => product.template_suffix !== 'rtw');
    }
    
    // Get condition counts
    fabric_count = fabric_conditions[0].value.length;
    color_count = color_conditions[0].value.length;
    price_exist = price_conditions[0].value.length;
    size_count = size_conditions[0].value.length;
    // Display total selected count by type
    handleFilterCountByType('size', size_count);
    handleFilterCountByType('color', color_count);
    handleFilterCountByType('fabric', fabric_count);

    if (is_api) {
        filteredResults = filterInventory(current_data, conditions);
        first_color = color_conditions[color_conditions.length - 1].value[0];  // Get last selected color
        first_size = size_conditions[0].value[0];
    } else {
        if (size_conditions[0].value.length > 0 && size_conditions[0].value.every(item => item === '30' || item === '32')) {
            filteredByCollection = filterByCollection(current_data, 'amsale-bridesmaids');
            filteredResults = filteredByCollection;  
        }
        
        // Filtering with Collection
        // Filter by colors
        if (color_count > 0) {
            // If we have filtered results use them otherwise use initial data
            if (filteredResults) {
                current_data = filteredResults;
            }

            const { value } = color_conditions[0];
            filteredColors = filterByColor(current_data, value);
            filteredResults = filteredColors;
            first_color = value[value.length - 1];  // Get the last color in the array
        }

        // Filter by fabrics
        if (fabric_count > 0) {
            if (filteredResults) {
                current_data = filteredResults;
            }

            const { value } = fabric_conditions[0];
            filteredFabrics = filterByFabric(current_data, value);
            filteredResults = filteredFabrics;    
        }
    }

    // Filter by price
    if (price_exist > 0) {
        if (filteredResults) {
            current_data = filteredResults;
        }

        const { value } = price_conditions[0];
        filteredPrices = filterByPrice(current_data, value, is_api);
        filteredResults = filteredPrices;
    } else {
        handleFilterCountByType('price', 0);
    }

    // Handle results
    if (filteredResults && filteredResults.length > 0) {
        // Replace product cards
        appendCollectionListHtml(filteredResults, is_api, first_color, first_size, inventory_data, color_dictionary);
        // Update product count label
        setProductCount(filteredResults.length);
    } else if (filteredResults && filteredResults.length === 0) {        
        // Display a no results message
        $('ul.product-cards-container').empty().append(`<li class="no-results">No results found</li>`);
        // Update product count label
        setProductCount(0);
    } else {
        if (getActiveCollection().data().type === 'reset' && is_api === false) {
            filteredResults = collection_data.products;
            if (madeToOrderSelected) {
                filteredResults = filteredResults.filter(product => product.template_suffix !== 'rtw');
            } else {
                console.log('Resetting to initial data (including RTW products)', filteredResults);
            }
        } else {
            let unfiltered = getDataToFilter(is_api);
            if (madeToOrderSelected) {
                filteredResults = unfiltered.filter(product => product.template_suffix !== 'rtw');
            } else {
                filteredResults = unfiltered;
            }
        }
        appendCollectionListHtml(filteredResults, is_api, null, first_size, inventory_data, color_dictionary);
        // Update product count label
        setProductCount(filteredResults.length);      
    }

    // Save all selected filters to Storage
    setSessionStorage(conditions);        
}

function setFilterConditions(checked, value, type, conditions) {
    const results = conditions.filter(c => c.type === type.type);

    if (results.length > 0) {
      if ( (type.type !== 'price')) {
          if (checked) {
              results[0].value = [...results[0].value, value]
          } else {
              results[0].value = results[0].value.filter(function(e) { return e !== value });
          }
      } else {
          // results[0].value.push(value);
          results[0].value = value
      }
    }

    return conditions;
}

function defaultConditions() {
    return [
        { field: 'tags', type: 'fabric', value: [] },
        { field: 'tags', type: 'color', value: [] },
        { field: 'sizes', type: 'size', value: [] },
        { field: 'price', type: 'price', value: [] },
        { field: "position", type: "scroll", value: 0 },
        { field: "refine", type: "refine", value: "" },
        { field: "availability", type: "availability", value: ['in-stock', 'made-to-order' ] }
    ];
}

function rangeDefaults() {
    return {
        "min": parseInt($('input.range-max').attr('min')),
        "max": parseInt($('input.range-max').attr('max')),
        "progress_left": 0,
        "progress_right": 0
    };
}

function productHasColorOption(product, is_api = false) {
    if (is_api) {
        const color_option = product.options.filter(option => option.name.toLowerCase() === 'color');
        if (color_option.length > 0) {
            return true;
        }
    }
    return false;
}

// Function to match swatches based on base color
function getMatchingSwatches(baseColor, colorDictionary, productSwatches = []) {
    const exact = [];
    const softMatches = [];
  
    if (typeof baseColor !== 'string') {
      return [];
    }
  
    const baseLower = baseColor.toLowerCase();
  
    for (const swatch in colorDictionary) {
      if (!colorDictionary.hasOwnProperty(swatch)) continue;
  
      const base = colorDictionary[swatch]?.base?.toLowerCase();
      if (!base) continue;
  
      const baseParts = base.split(',').map(p => p.trim());
  
      // Exact match 
      if (swatch.toLowerCase() === baseLower && productSwatches.includes(swatch.toLowerCase())) {
        exact.push(swatch);
      } 
      // Soft match
      else if (baseParts.includes(baseLower) && productSwatches.includes(swatch.toLowerCase())) {
        softMatches.push(swatch);
      }
    }
  
    return [...exact, ...softMatches];
  }
  
  function getSwatchColorsFromVariants(product) {
    const swatches = new Set();
  
    if (!product || !Array.isArray(product.variants)) return [];
  
    if (Array.isArray(product.options)) {
      const colorOption = product.options.find(opt => opt.name.toLowerCase() === 'color');
      if (colorOption) {
        colorOption.values.forEach(val => swatches.add(val.toLowerCase()));
      }
    }
  
    if (Array.isArray(product.options_with_values)) {
      const colorOption = product.options_with_values.find(opt => opt.name.toLowerCase() === 'color');
      if (colorOption) {
        colorOption.values.forEach(val => swatches.add(val.toLowerCase()));
      }
    }
  
    return Array.from(swatches);
  }
  

  
  async function injectSwatchImage(product, baseColor, imgElementId) {
    const imgEl = document.getElementById(imgElementId);
    if (!imgEl) return;
  
    const productSwatches = product.swatches || getSwatchColorsFromVariants(product) || [];
    const matchingSwatches = getMatchingSwatches(baseColor, color_dictionary, productSwatches);
    const validSwatchMatch = matchingSwatches.find(swatch =>
      productSwatches.some(p => swatch.toLowerCase().includes(p.toLowerCase()))
    );
  
    const baseHandle = getProductHandle(product);
    if (!baseHandle) {
        injectVariantImageFallback(product, imgEl);

    };
  
    const swatchHandle = validSwatchMatch ? `${baseHandle}-${validSwatchMatch}` : baseHandle;
  
    const productData = await fetchProductData(swatchHandle);
    if (productData && validSwatchMatch) {
      const imgSrc = productData.featured_image || productData.images?.[0]?.src || productData?.[0]?.src_540x;
      if (imgSrc) {
        imgEl.src = imgSrc;
        imgEl.alt = `Swatch image for ${baseColor || product.title}`;
      } else {

        injectVariantImageFallback(product, imgEl);
      }
    } else {
      injectVariantImageFallback(product, imgEl);
    }
  }
  
  async function injectVariantImageFallback(product, imgEl) {
    if (!product || !imgEl) return;
  
    const baseHandle = getProductHandle(product);
    if (!baseHandle) return;
  
    const productData = await fetchProductData(baseHandle);
    if (productData) {
      const imgSrc = productData.featured_image || productData.images?.[0]?.src || productData?.[0]?.src_540x;
      if (imgSrc) {
        imgEl.src = imgSrc;
        imgEl.alt = `Image for ${product.title}`;
      } 
    } else {
      console.warn('Failed to fetch fallback image data for product:', baseHandle);
    }
  }
  
  function getProductHandle(product) {
    return product.handle || product.url?.split('/products/')[1]?.split('/')[0];
  }

  async function appendCollectionListHtml(products, is_api = false, baseColor = '', first_size = '', productData = {}, color_dictionary = {}) {
    color_dictionary = color_dictionary || {};
    let html_promises = [];
  
    // Generate promises for all product cards
    for (const product of products) {
      html_promises.push(
        (async () => {
          const productHandle = product.handle;
          const compareAtPrice = productData[productHandle] || null;
          if (is_api) {
            if (productHasColorOption(product, is_api)) {
              return await buildProductCard(product, is_api, baseColor, first_size, null, color_dictionary);
            }
          } else if (current_collection_private === privateCollection) {
            return await buildProductCard(product, is_api, baseColor, first_size, compareAtPrice, color_dictionary);
          } else {
            return await buildProductCard(product, is_api, baseColor, first_size, null, color_dictionary);
          }
          return ''; // Return empty string if conditions aren't met
        })()
      );
    }
  
    // Wait for all card HTML to be generated
    const html_array = await Promise.all(html_promises);
    const html_to_append = html_array.join('');
  
    // After generating the HTML, append it to the product cards container
    $('ul.product-cards-container').empty().append(html_to_append);
  
    // AFTER DOM is fully injected
    products.forEach(product => {
      const fullProduct = productData[product.handle] || product;
      const baseHandle = fullProduct.url?.split('/products/')[1]?.split('/')[0] || fullProduct.handle;
      const tempImageId = `img-${baseHandle}`;
      injectSwatchImage(fullProduct, baseColor, tempImageId);
    });
  
    if (baseColor) {
      $('ul.product-cards-container').attr('data-color-group', baseColor);
    }
  }


async function buildProductCard(product, is_api = false, baseColor = '', first_size = '', compareAtPrice = null, color_dictionary = {}) {
  const baseHandle = product.url?.split('/products/')[1]?.split('/')[0] || product.handle;
  const tempImageId = `img-${baseHandle}`;

  


  // Build the image HTML
  const productImageHTML = buildCardImages(product, is_api, baseColor, color_dictionary);
  let imageHtml;

  if (tempImageId) {
    imageHtml = `<img id='${tempImageId}' class='product-card-image' src='' alt='' loading='lazy' />`;
  } else {
    imageHtml = productImageHTML;
  }

  // Build the final HTML card
  let html_card = `
    <li class='grid__item medium-up--one-third product-card-list-item'>
      <div class='custom__product-card' data-color='${baseColor}'>
        <a href='${buildCardProductUrl(product, is_api, baseColor, first_size)}' aria-label='Link to ${product.title}'>
          <div class='hover-reveal-effect'>
            <div style='position: relative;'>
            ${imageHtml}
            ${product.image_tag ? `<span class='image-tag'>${product.image_tag}</span>` : ''}
            </div>
          </div>
          <div class='product-card-details'>
            ${buildCardDetails(product, is_api, compareAtPrice)}
          </div>
        </a>
      </div>
    </li>
  `;

  return html_card;
}

function buildCardColorPalette(product, is_api = false) {
    let cardPaletteHtml = "";
    const swatch_count = !is_api ? parseInt(product.swatches.length) : parseInt(product.options.filter(option => option.name === 'Color')[0].values.length);
    const product_swatches = !is_api ? product.swatches : product.options.filter(option => option.name === 'Color')[0].values;
    const hidden_asset_path = $('input#hidden-asset-url').val();
    const asset_url = hidden_asset_path.substring(0, hidden_asset_path.indexOf('black.jpg'));
  
    if (swatch_count > 1) {
      cardPaletteHtml += `<div class='card-color-palette'>`;
      for (let index = 0; index < swatch_count; index++) {
        if (index <= 4) {
          const asset_name = product_swatches[index];
          cardPaletteHtml += `
          <img
            class='card-color'
            src='${asset_url + asset_name.toLowerCase()}.jpg'
            alt='Swatch of color ${ asset_name }'
            loading='lazy'
            width='12'
            height='12' />
          `;
        } else {
          break;
        }
      }
  
      if (swatch_count > 5) {
        cardPaletteHtml += `<div class='more-colors-label'>+ ${ (swatch_count - 5) }</div>`;
      }
      cardPaletteHtml += `</div>`;
    }
  
    return cardPaletteHtml;
  }
  
  // Function to build card details including pricing
  function buildCardDetails(product, is_api = false, compareAtPrice = null) {
    let cardDetailsHtml = "";
  
    if (current_collection_private === privateCollection && product.price) {
      let productPrice = !is_api ? product.price : "$" + (product.price / 100).toFixed(2).replace(".00", "");
      let productCompareAtPrice = product.compare_at_price ? "$" + (product.compare_at_price / 100).toFixed(2).replace(".00", "") : '';
  
      cardDetailsHtml += `<div class='product-card__title_wrapper'><div class='card-flex-wrapper'>` +
      `<h4>${product.title}</h4>` +
      `</div><div class='card-flex-wrapper price-wrapper'><h5><span style="font-size:1.07143em; color: #95ae9d;"><s>${productCompareAtPrice}</s></span>` + " " + " " + `<span class="price-item price-item--sale"> ${productPrice}</span></h5>` +
      buildCardColorPalette(product, is_api) +
      `</div></div>`;
    } else { 
      cardDetailsHtml += `<div class='product-card__title_wrapper'><div class='card-flex-wrapper'>` +
      `<h4>${ product.title }</h4>` +
      `</div><div class='card-flex-wrapper price-wrapper'><h5>${ !is_api ? product.variant[0].price : "$" + product.variants[0].price.replace('.00', '') }</h5>` +
      buildCardColorPalette(product, is_api) +
      `</div></div>`;
    }
  
    return cardDetailsHtml;
  }
  
function buildCardProductUrl(product, is_api = false, first_color = '', first_size = '') {
    let product_url = '';
    let filtered_variant;
  
    if (!product) return '#';
  
    if (current_collection_private === privateCollection) {
      if (product.url) {
        return product.url;
      } else if (product.handle) {
        return `/products/${product.handle}`;
      }
    }
  
    if (is_api) {
      if (product.variants && product.variants.length > 0) {
        filtered_variant = product.variants.find(v => {
          const variantColor = v.option1?.toLowerCase().replace(/[\s/]/g, '-');
          const has_color = variantColor === first_color;
          const has_size = (
            v.option1?.toLowerCase() === first_size ||
            v.option2?.toLowerCase() === first_size
          );
          return has_color || has_size;
        });
  
        if (filtered_variant && filtered_variant.handle) {
          product_url = filtered_variant.handle;
        } else {
          product_url = product.handle || '';
        }
      } else {
        product_url = product.handle || '';
      }
    } else {
      product_url = product.variant?.[0]?.url || product.url || `/products/${product.handle}`;
    }
  
    return product_url.startsWith('/products/') ? product_url : `/products/${product_url}`;
  }
  
  function buildCardImages(product, is_api = false) {    
    // Get optmized image from Liquid template JSON
    let optimized_images;
    if (current_collection_private === privateCollection && product.featured_image) {
        optimized_images = product.featured_image;
    }else if (is_api) {
        optimized_images = all_images.products.filter(i => i.sku === product.sku);
    } else {
        optimized_images = all_images.products.filter(i => i.sku === product.variant[0].sku);
    }

    let product_images_html = "";
    if(current_collection_private === privateCollection && product.featured_image)   {
        product_images_html += `<img src='${product.featured_image}' alt='${product.title}'  />`;
    }  
    else if (optimized_images && optimized_images.length > 0 ) {
        for (let index = 0; index < optimized_images[0].images.length; index++) {
            const image = optimized_images[0].images[index];
            if (index <= 1) {
                product_images_html += image.img_540x_html;
            } else {
                break;
            }
        }
    } 
    return product_images_html;
}

function isChecked(checkbox) {
    if(checkbox.is(':checked')) {
        return true
    } else {
        return false;
    }
}

function handleFilterCountByType(type, count) {
    if (count > 0) {
        $(`.${type}-label`).find('span i').text(`(${count})`);
    } else {
        $(`.${type}-label`).find('span i').text("");
    }
}

function isInteger(value) {
    return /^[0-9]+$/.test(String(value));
}

function parseStringArrayToNumbers(data) {
    return data.map(function(item) {
        if (isInteger(item)) {
            return parseInt(item);
        } else {
            return parseFloat(item.replace(/,/g, '').replace(/\./, ','));
        }
    });
}

function parseDecimal(decimal) {
    return parseFloat(decimal.replace(/,/g, '').replace(/\./, ','));
}

function handleClearAction(action) {
    if (action === 'show') {
        $('a.clear-filters').addClass('show');
    } else {
        $('a.clear-filters').removeClass('show');
    }
}

function setProductCount(count) {
    if (count > 0) {
        $('.filters-toolbar__product-count').html(count > 1 ? `${count} products` : `${count} product`);
    } else {
        $('.filters-toolbar__product-count').html("0 product");
    }
}

function handleActiveCollection(element, conditions = []) {
    $('a.collection-filter').removeClass('active');
    element.addClass('active');    
    // Set refined collection in storage
    if (conditions.length > 0) {
        let refine_conditions = conditions.filter(c => c.type === 'refine');
        refine_conditions[0].value = element.attr('data-type');
        setSessionStorage(conditions);
    }
    return conditions;
}

function resetRangeInput() {    
    const { min, max, progress_left, progress_right } = rangeDefaults();    
    const progress_bar = document.querySelector(".slider .progress");
    
    $('input.range-min').val(min);
    $('input.range-max').val(max);
    progress_bar.style.left = progress_left + "%";
    progress_bar.style.right = progress_right + "%";
    $('span.lowest-range').text(`$${min}`);
    $('span.highest-range').text(`$${max}`);
}

function resetFilters(conditions) {
    $('.checkb-filter').prop('checked', false);
    resetRangeInput();
    conditions = defaultConditions();
    handleActiveCollection($('.collection-filter.reset'));
    $('.filter-chip').remove();
    $('.collapsible-label').find('span i').text("");
    filterByManyConditions(collection_data.products, conditions);
    return conditions;
}

function resetFiltersSimple() {
    $('.checkb-filter').prop('checked', false);
    resetRangeInput();
    handleActiveCollection($('.collection-filter.reset'));
    $('.collapsible-label').find('span i').text("");
}

function getActiveCollection() {
    return $('a.collection-filter.active');
}

function setActiveCollection(conditions) {
    const result = conditions.filter(c => c.type === 'refine');
    if (result[0].value !== '') {
        $('a.collection-filter').removeClass('active');
        $(`a.collection-filter[data-type=${result[0].value}]`).addClass('active');
    }
}

function is_api() {
    const instock_chbx = $('input.checkb-filter').filter(function() {
        return $(this).val() === 'in-stock'
    });

    const mto_chbx = $('input.checkb-filter').filter(function() {
        return $(this).val() === 'made-to-order'
    });

    const instock_has_checked = instock_chbx.filter(function() {
        return $(this).is(':checked')
    });

    const mto_has_checked = mto_chbx.filter(function() {
        return $(this).is(':checked')
    });


    if (instock_has_checked.length > 0 && mto_has_checked.length === 0) {
        return true;
    }
    return false;
}

function convertAndCleanTags(tags) {    
    let converted_tags = Array.isArray(tags) ? tags : tags.split(',');
    return converted_tags.map(t => t.toLowerCase().trim());
}

function getPreFilteredTag(pathname) {
    let path_tag;
    if (pathname.includes('evening-jumpsuit')) {
        path_tag = 'evening-jumpsuit';
    } else if (pathname.includes('evening-mob')) {
        path_tag = 'evening-mob';
    } else if (pathname.includes('holiday')) {
        path_tag = 'holiday';
    } else if (pathname.includes('lwd-jumpsuit')) {
        path_tag = 'lwd-jumpsuit';
    }
    return path_tag;
}

function getProductsForCollectionType(data, type, is_api = false) {
    if (is_api) {
        return data.products.filter(product => {
        const cleanedTags = convertAndCleanTags(product.tags);
        const typeVariants = [type.toLowerCase(), type.toLowerCase() + "s", "amsale-" + type.toLowerCase()];
    
        const tagMatch = typeVariants.some((typeVariant) =>
          cleanedTags.includes(typeVariant)
        );
        return tagMatch;
    });
      
    } else {
    return data.products.filter((product) => {
        const cleanedTags = convertAndCleanTags(product.tags);
        const typeVariants = [type.toLowerCase(), type.toLowerCase() + "s", "amsale-" + type.toLowerCase()];

        const tagMatch = typeVariants.some((typeVariant) =>
          cleanedTags.includes(typeVariant)
        );
    
        const collectionMatch = product.collections?.some((collection) => {
          return typeVariants.some((typeVariant) =>
            collection.handle.toLowerCase().includes(typeVariant)
          );
        });
  
        return tagMatch || collectionMatch;
      });
    }
  }

function getDataToFilter(is_api = false) {    
    const current_type = getActiveCollection().data().type;

    if (current_type === 'reset' && is_api === false) {
        return collection_data.products;
    } else if (is_api) {
        if (current_type !== 'reset') {
            return getProductsForCollectionType(inventory_data, current_type, is_api);
        } else {
            return inventory_data.products;
        }
    } else {
        return getProductsForCollectionType(collection_data, current_type);
    }
}


  
  
function adjustRangeInput(conditions) {    
    // Initialize Price Range    
    const results = conditions.filter(c => c.type === 'price');    

    if (results[0].value.length > 0) {
        const range = document.querySelector(".slider .progress"),
        rangeInput = document.querySelectorAll(".range-input input");
        let minVal = parseInt(results[0].value[0]),
            maxVal = parseInt(results[0].value[1]);
        const realMin = rangeInput[0].min;
        const realMax = rangeInput[0].max;

        const minPosition = ((minVal - realMin) / (realMax - realMin)) * 100;
        const maxPosition = ((maxVal - realMin) / (realMax - realMin)) * 100;
        range.style.left = minPosition + "%";
        range.style.right = 100 - maxPosition + "%";
        $('input.range-min').val(minVal);
        $('input.range-max').val(maxVal);        
        $('span.lowest-range').text(`$${minVal}`);
        $('span.highest-range').text(`$${maxVal}`);
        handleFilterChip({min: minVal, max: maxVal})
    }
}

function setScrollPosition(conditions) {
    const result = conditions.filter(c => c.type === 'scroll');
    setTimeout(() => {
        window.scrollTo(0, result[0].value);
    }, 500);
}

function getSessionStorage() {
    if (sessionStorage.getItem("plp_filters")) {
        return JSON.parse(sessionStorage.getItem("plp_filters"));
    }
}

function setSessionStorage(conditions) {
    if (sessionStorage.getItem("plp_filters")) {        
        sessionStorage.setItem("plp_filters", JSON.stringify(conditions));
    } else {
        sessionStorage.setItem("plp_filters", JSON.stringify(defaultConditions()));
    }
}

function setStorageCollectionID(id) {
    let sameCollection = false;
    if (checkCollectionID(id)) {
        sameCollection = true;
    } else {
        sessionStorage.setItem("plp_filters_collection_id", JSON.stringify(id));
    }
    return sameCollection;   
}

function getStorageCollectionID() {
    const sessionCollection = sessionStorage.getItem("plp_filters_collection_id");
    if (sessionCollection) {
        return JSON.parse(sessionCollection);
    } else {
        return false;
    }
}

function checkCollectionID(id) {
    let sameCollection = false;
    const sessionData = getStorageCollectionID();
    if (sessionData) {
        if (sessionData === id) {
            sameCollection = true;
        }
    }
    return sameCollection;
}

function conditionsExists(conditions) {    
    return conditions.some(condition => condition.value.length > 0 || (condition.type === 'refine' && condition.value !== ""));
}

function recheckCheckboxes(conditions) {
    fabric_conditions = conditions.filter(c => c.type === 'fabric');
    color_conditions = conditions.filter(c => c.type === 'color');
    size_conditions = conditions.filter(c => c.type === 'size');

    if (size_conditions.length > 0) {
        size_conditions.map(s => {
            if ($(`#size-${s.value}`).length > 0) {
              s.value.map(size => {
                $(`#size-${size}`).prop('checked', true);
                handleFilterChip($(`#size-${size}`)[0]) 
              })
            }
        });
    }

    if (color_conditions.length > 0) {
        color_conditions.map(c => {
            if ($(`#color-${c.value}`).length > 0) {
              c.value.map(color => {
                $(`#color-${color}`).prop('checked', true);
                handleFilterChip($(`#color-${color}`)[0]) 
              })
            }
        });
    }

    if (fabric_conditions.length > 0) {
        fabric_conditions.map(f => {
            if ($(`#fabric-${f.value}`).length > 0) {
              f.value.map(fabric => {
                $(`#fabric-${fabric}`).prop('checked', true);
                handleFilterChip($(`#fabric-${fabric}`)[0]) 
              })
            }
        });
    }
}

function applyConditionsFromStorage(conditions) {    
    const sessionData = getSessionStorage();
    if (sessionData) {
        conditions = sessionData;

        if (conditionsExists(conditions)) {
            // Re-apply checked checkboxes
            recheckCheckboxes(conditions);
            // Re-apply Range slider values
            adjustRangeInput(conditions);
            // Check to see if any Sizes selected
            const is_api_check = is_api();
            // If refinement selection exists, re-apply proper refinement link
            setActiveCollection(conditions);            
            // filter with conditions from Storage          
            filterByManyConditions(getDataToFilter(is_api_check), conditions, is_api_check);
            // display clear filters button
            handleClearAction('show');            
        }
    } else {
        // If no conditions in storage, we init conditions back to default
        conditions = defaultConditions();        
    }
    // Display back the products
    $('ul.product-cards-container').css('opacity', '1');
    // Scroll user back to last known position
    setScrollPosition(conditions);

    return conditions;
}

window.addEventListener('load', function () {
    const availabilityTypes = ['made-to-order', 'in-stock'];
    availabilityTypes.forEach(type => {
        $(`#availability-${type}`).prop('checked', true);
        if ($(`#availability-${type}`).prop('checked')) {
            // Using JS cause its cleaner than $(`#availability-${type}`)[0]
            handleFilterChip(document.getElementById(`availability-${type}`));
        }
    });
});

function handleFilterChip(element){
  let type = element.min || element.max ? 'price' : element.dataset.type

  switch(type) {
    case 'availability':
    case 'size':
    case 'color':
    case 'fabric':
      createGenericChip(element)
      break;
    case 'price':
      createPriceChip(element.min, element.max)
      break;
    default:
      console.log('Element does not match any type')
  }
}

function createGenericChip(element){
  let chipSelector = `.filter-chip[data-type="${element.dataset.type}"][data-value="${element.value}"]`;
  const labelText = $(`label[for="${element.id}"]`).text().trim();

  if ($(chipSelector).length > 0){
    // Remove chip
    $(chipSelector).remove();
  } else {
    // Create chip
    chipHtml = `
                <div class="filter-chip" data-type="${element.dataset.type}" data-value="${element.value}">
                    ${labelText} <button class="remove-filter-btn" data-type="${element.dataset.type}" data-value="${element.value}">${chip_svg}</button>
                </div>`;
            $('#filter-chips-container').prepend(chipHtml);
  }
}

function createPriceChip(min, max, reset = false){
  const priceVal = `$${min} - $${max}`;
  const priceSpread = [min, max];

  let chipSelector = '.filter-chip[data-type="price"]';

  if (reset) {
    resetRangeInput()
    $(chipSelector).remove()
  } else {
    $(chipSelector).remove()
    chipHtml = `
                <div class="filter-chip" data-type="price">
                ${priceVal} <button class="remove-filter-btn" data-type="price" data-value="${priceSpread}">${chip_svg}</button>
                </div>`;
            $('#filter-chips-container').prepend(chipHtml);
  }
}

// Function to handle remove button click
$(document).on('click', '.remove-filter-btn', function () {
    const type = $(this).data('type');
    let value = $(this).data('value').toString();
    let checked = false;
    let conditions = getSessionStorage()
    conditions = conditions.map(item => {
        if (item.type === type) {
            if (type === 'price') {
                item.value = []
            } else {
                // Filter out the specified value from the value array
                item.value = item.value.filter(val => val !== value);
            }
        }
        return item;
    });

    filterByManyConditions(getDataToFilter(is_api()), conditions, is_api());
    $(`input.checkb-filter[data-type="${type}"][value="${value}"]`).prop('checked', false);
    if (type === 'price') {
        $(`.filter-chip[data-type="${type}"]`).remove();
        resetRangeInput()
    }
    if (type === 'availability' && value === 'made-to-order'){
        $(`.filter-chip[data-type="${type}"][data-value="${value}"]`).remove();
        filterByManyConditions(inventory_data.products, conditions, is_api());
    } else {
        filterByManyConditions(getDataToFilter(is_api()), conditions, is_api());
    }
    $(`.filter-chip[data-type="${type}"][data-value="${value}"]`).remove();

});

